<div
  [matMenuTriggerFor]="actionContextMenu"
  #actionContextTrigger
  [style.position]="'fixed'"
  [style.left.px]="actionContextMenuX"
  [style.top.px]="actionContextMenuY"
></div>
<div class="flex flex-col w-full h-full gap-2 p-2 justyfy-between text-nowrap">
  <div
    class="sia-side-panel sia-side-panel-background"
    [class]="groupsOrComponentsPanelVisible ? 'visible' : ''"
  >
    <div class="flex items-center justify-between">
      <span class="text-2xl text-secondary">{{
        'Elementi' | siaTranslate
      }}</span>
      @if (selectedGroupOrComponentItem) {
        <button mat-icon-button (click)="closePanel()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
    <sia-search-box [(searchExp)]="filterGroupComp"> </sia-search-box>
    <div class="flex-grow overflow-y-auto">
      <mat-tab-group>
        <mat-tab [label]="'Gruppi' | siaTranslate">
          <ng-container
            [ngTemplateOutlet]="sidebarItemElement"
            [ngTemplateOutletContext]="{
              sidebarElements: componentActionGroups,
              type: 'group',
            }"
          ></ng-container>
        </mat-tab>
        <mat-tab [label]="'Componenti' | siaTranslate">
          <ng-container
            [ngTemplateOutlet]="sidebarItemElement"
            [ngTemplateOutletContext]="{
              sidebarElements: components,
              type: 'component',
            }"
          ></ng-container>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  @if (
    selectedGroupOrComponentItem && selectedGroupOrComponentItem.type != 'group'
  ) {
    <sia-select-box
      class="m-auto"
      [selectBoxOptions]="{
        dbKey: 'component.ComponentActionGroups',
        value: selectedGroupOrComponentItem.actionGroupId,
      }"
      [(value)]="selectedGroupOrComponentItem!.actionGroupId"
      label="Gruppo azioni"
      (valueChanged)="updateSelectedItemGroup()"
    >
    </sia-select-box>
  }
  <div class="flex flex-col items-center justify-between flex-grow w-full">
    <ng-container
      [ngTemplateOutlet]="actionsForMode"
      [ngTemplateOutletContext]="{ mode: 'read', title: 'Lettura' }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="actionsForMode"
      [ngTemplateOutletContext]="{ mode: 'update', title: 'Aggiornamento' }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="actionsForMode"
      [ngTemplateOutletContext]="{ mode: 'create', title: 'Creazione' }"
    ></ng-container>
  </div>
</div>

<ng-template
  #sidebarItemElement
  let-sidebarElements="sidebarElements"
  let-type="type"
>
  <div class="flex flex-col gap-2">
    @for (item of sidebarElements; track $index) {
      <div
        class="relative flex flex-row items-center gap-2 p-2 overflow-hidden transition-all duration-200 sia-hover"
        (click)="selectItem(item, type)"
        [class]="
          selectedGroupOrComponentItem?.id === item.id
            ? 'bg-secondary-container rounded-lg'
            : ''
        "
      >
        <mat-icon>
          {{ item.type == 'group' ? 'table_view' : (item.icon ?? 'help') }}
        </mat-icon>
        <div class="flex flex-col ellipsis">
          <span class="txt-lg text-secondary ellipsis">{{
            item.description
          }}</span>
          <span class="text-xs text-outline ellipsis">{{ item.id }}</span>
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #actionsForMode let-mode="mode" let-title="title">
  <div
    class="flex flex-col items-center justify-center max-w-full gap-2 p-2 surface-low rounded-xl"
  >
    <div class="flex flex-row items-center gap-2">
      <span class="text-xl text-secondary">{{ title | siaTranslate }}</span>
      <button
        [disabled]="selectedGroupOrComponentItem ? false : true"
        mat-icon-button
        [siaTooltip]="'Aggiungi azione'"
        [matMenuTriggerFor]="addActions"
        [matMenuTriggerData]="{
          actions: selectedItemActions[mode],
          mode: mode,
        }"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div
      class="flex flex-row items-center w-full max-w-full overflow-x-auto actions-mode-list flex-nowrap"
      cdkDropList
      cdkDropListOrientation="horizontal"
      [cdkDropListData]="selectedItemActions[mode]"
      (cdkDropListDropped)="moveItem($event)"
    >
      @for (
        action of selectedItemActions[mode];
        track $index;
        let first = $first;
        let last = $last
      ) {
        @if (action.actionType != 'group') {
          <div
            class="relative flex flex-row items-center justify-center gap-2 px-2 py-3 overflow-hidden border border-solid surface h-fit min-w-fit"
            cdkDrag
            (cdkDragStarted)="dragging = true"
            (cdkDragEnded)="dragging = false"
            [cdkDragDisabled]="
              selectedGroupOrComponentItem?.type != 'group' &&
              action.componentActionGroupId
            "
            [style.cursor]="
              selectedGroupOrComponentItem?.type != 'group' &&
              action.componentActionGroupId
                ? ''
                : 'pointer'
            "
            (click)="openActionProperties(action)"
            (contextmenu)="
              openContextMenu($event, selectedItemActions[mode], $index)
            "
            [class]="
              first && last
                ? 'rounded-xl'
                : first
                  ? 'rounded-l-xl'
                  : last
                    ? 'rounded-r-xl'
                    : ''
            "
          >
            <ng-container
              [ngTemplateOutlet]="actionTemplate"
              [ngTemplateOutletContext]="{
                action: action,
                first: first,
                last: last,
              }"
            >
            </ng-container>
          </div>
        } @else {
          <div
            class="bg-secondary-container group-actions-list relative flex h-fit w-fit flex-col items-center gap-1 border border-solid border-[var(--mat-sys-secondary)] px-2 py-3"
            cdkDropList
            cdkDrag
            (cdkDragStarted)="dragging = true"
            (cdkDragEnded)="dragging = false"
            [cdkDragDisabled]="
              selectedGroupOrComponentItem?.type != 'group' &&
              action.componentActionGroupId
            "
            [cdkDropListData]="selectedItemGroupActions[mode][action.id]"
            cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="moveItem($event)"
            [class]="
              first && last
                ? 'rounded-xl'
                : first
                  ? 'rounded-l-xl'
                  : last
                    ? 'rounded-r-xl'
                    : ''
            "
          >
            <div class="flex flex-row items-center gap-2">
              <mat-icon>{{ action.icon }}</mat-icon>
              <div class="flex flex-col">
                <span
                  class="text-secondary"
                  [class]="
                    action.specificName ? 'text-tertiary font-semibold' : ''
                  "
                  >{{ action.specificName ?? action.name }}</span
                >

                <span class="text-xs">{{ action.id }}</span>
              </div>
              <mat-divider
                [vertical]="true"
                [style.height]="'1.75rem'"
              ></mat-divider>
              <sia-check-box
                [(value)]="action.alwaysGrouped"
                label="Sempre compatto"
                [disabled]="true"
              >
              </sia-check-box>
              <mat-divider
                [vertical]="true"
                [style.height]="'1.75rem'"
              ></mat-divider>
              <button
                mat-icon-button
                [siaTooltip]="'Aggiungi azione'"
                [matMenuTriggerFor]="addActions"
                [matMenuTriggerData]="{
                  actions: selectedItemGroupActions[mode][action.id],
                  group: action.id,
                  mode: mode,
                }"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
            @if (
              selectedItemGroupActions[mode][action.id] &&
              selectedItemGroupActions[mode][action.id].length > 0
            ) {
              <div class="flex flex-row items-center p-2">
                @for (
                  groupAction of selectedItemGroupActions[mode][action.id];
                  track $index;
                  let first = $first;
                  let last = $last
                ) {
                  <div
                    class="relative flex flex-row items-center justify-center gap-2 px-2 py-3 overflow-hidden border border-solid surface h-fit"
                    cdkDrag
                    (cdkDragStarted)="dragging = true"
                    (cdkDragEnded)="dragging = false"
                    [cdkDragDisabled]="
                      selectedGroupOrComponentItem?.type != 'group' &&
                      groupAction.componentActionGroupId
                    "
                    [style.cursor]="
                      selectedGroupOrComponentItem?.type != 'group' &&
                      groupAction.componentActionGroupId
                        ? ''
                        : 'pointer'
                    "
                    (contextmenu)="
                      openContextMenu(
                        $event,
                        selectedItemGroupActions[mode][action.id],
                        $index
                      )
                    "
                    (click)="openActionProperties(groupAction)"
                    [class]="
                      first && last
                        ? 'rounded-xl'
                        : first
                          ? 'rounded-l-xl'
                          : last
                            ? 'rounded-r-xl'
                            : ''
                    "
                  >
                    <ng-container
                      [ngTemplateOutlet]="actionTemplate"
                      [ngTemplateOutletContext]="{
                        action: groupAction,
                        first: first,
                        last: last,
                      }"
                    >
                    </ng-container>
                  </div>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
</ng-template>

<ng-template
  let-action="action"
  #actionTemplate
  let-first="first"
  let-last="last"
>
  @if (
    selectedGroupOrComponentItem?.type != 'group' &&
    action.componentActionGroupId
  ) {
    <div
      class="absolute inset-0 bg-black bg-opacity-20"
      [siaTooltip]="'Azione ereditata dal gruppo'"
    ></div>
  }
  <mat-icon>{{ action.icon ?? 'check_box_outline_blank' }}</mat-icon>
  <div class="flex flex-col">
    <span
      class="text-secondary"
      [class]="action.specificName ? 'text-tertiary font-semibold' : ''"
      >{{ action.specificName ?? action.name }}</span
    >
    <span class="text-xs">{{ action.id }}</span>
  </div>
  <span
    class="text-tertiary absolute left-1/2 top-[2px] -translate-x-1/2 text-xs"
  >
    {{ action.style }}
  </span>
</ng-template>

<mat-menu #actionContextMenu>
  <div mat-menu-item (click)="openRenameDialog()">
    <mat-icon class="">edit</mat-icon>
    {{ 'Rinomina azione' | siaTranslate }}
  </div>
  @if (
    (selectedGroupOrComponentItem?.type != 'group' &&
      !selectedAction?.componentActionGroupId) ||
    selectedGroupOrComponentItem?.type == 'group'
  ) {
    <div mat-menu-item (click)="deleteSelectedAction()">
      <mat-icon class="error">delete</mat-icon>
      {{ 'Elimina azione' | siaTranslate }}
    </div>

    <div mat-menu-item (click)="modifyActions()">
      <mat-icon class="">edit_note</mat-icon>
      {{ 'Modifica azione' | siaTranslate }}
    </div>
  }

  @if (
    selectedAction &&
    selectedAction.specificName &&
    ((selectedGroupOrComponentItem?.type != 'group' &&
      !selectedAction.renamedByGroup) ||
      (selectedGroupOrComponentItem?.type == 'group' &&
        selectedAction.renamedByGroup))
  ) {
    <div mat-menu-item (click)="resetName()">
      <mat-icon class="">undo</mat-icon>
      {{ 'Ripristina nome' | siaTranslate }}
    </div>
  }
</mat-menu>

<mat-menu #addActions="matMenu">
  <sia-search-box
    class="mx-2 mb-2"
    stopClickPropagation
    [(searchExp)]="filterActions"
    (keydown)="$event.stopPropagation()"
  ></sia-search-box>
  <div class="h-[340px] overflow-auto">
    <ng-template
      matMenuContent
      let-actions="actions"
      let-mode="mode"
      let-group="group"
    >
      @for (action of actionsList; track $index) {
        @if (!(group && action.type == 'group')) {
          <div
            class="flex flex-row items-center gap-2"
            mat-menu-item
            (click)="addAction(action, actions, mode, group)"
            [style]="
              action.type == 'group'
                ? 'background-color: var(--mat-sys-secondary-container); color: var(--mat-sys-on-secondary-container);'
                : ''
            "
          >
            <mat-icon>{{ action.icon }}</mat-icon>
            <div class="flex flex-col">
              <span class="text-secondary">{{ action.name }}</span>
              <span class="text-xs">{{ action.id }}</span>
            </div>
          </div>
        }
      }
    </ng-template>
  </div>
</mat-menu>
